/* eslint-disable */
export default [
  {
    header: 'Stockage',
    action: 'read_archives',
    resource: 'Bibliothèque',
  },
  {
    title: 'Bibliothèque',
    route: 'files-manager-home',
    icon: 'FolderIcon',
    action: 'read_archives',
    resource: 'Bibliothèque',
  },
  {
    title: "CPTu",
    route: "apps-cptu-list",
    icon: "DownloadCloudIcon",
    action: "import_cptu_tests",
    resource: "CPTu",
  },
]